import { FC } from 'react';
import { Menu } from 'antd';
import ContextualMenu from 'components/atoms/ContextualMenu';
import { ProjectContextualMenuTranslations } from 'components/pages/ProjectPage/resources/models';

interface Props {
  onClickEditButton: () => void;
  onClickNotifyButton: () => void;
  onClickDeleteProjectButton: () => void;
  notifyButtonEnabled: boolean;
  showDeleteButton: boolean;
  translations: ProjectContextualMenuTranslations;
}

const ProjectMenuExtra: FC<Props> = ({
  onClickEditButton,
  onClickNotifyButton,
  onClickDeleteProjectButton,
  notifyButtonEnabled,
  showDeleteButton,
  translations,
}) => {
  return (
    <ContextualMenu placement={'bottomRight'} menu={
      <Menu>
        <Menu.Item key={'edit'} onClick={onClickEditButton}>
          {translations.editButton}
        </Menu.Item>
        {showDeleteButton && (
          <Menu.Item key={'delete'} onClick={onClickDeleteProjectButton} danger={true}>
            {translations.deleteButton}
          </Menu.Item>
        )}
        {notifyButtonEnabled && (
          <Menu.Item key={'notify'} onClick={onClickNotifyButton}>
            {translations.notifyButton}
          </Menu.Item>
        )}
      </Menu>
    } />
  );
}

export default ProjectMenuExtra;